import { formatPropertyAddress } from '../utils/propertyAddress';
import { SITE_CONFIG } from '../config';
const key = `assistantPreferences_${SITE_CONFIG.SITE_ID}`;
export const preferenceTypes = ['must_haves', 'preferences', 'dealbreakers'];
export function cleanPreferences(value = {}) {
  if (!value || typeof value !== 'object') value = {};
  return Object.fromEntries(preferenceTypes.map(type => [type, [...new Set((Array.isArray(value[type]) ? value[type] : []).filter(x => typeof x === 'string').map(x => x.trim().slice(0, 200)).filter(Boolean))].slice(0, 12)]));
}
export function readPreferences() {
  try {
    return cleanPreferences(JSON.parse(localStorage.getItem(key) || '{}'));
  } catch {
    return cleanPreferences();
  }
}
export function writePreferences(value) {
  const clean = cleanPreferences(value);
  try {
    localStorage.setItem(key, JSON.stringify(clean));
  } catch {/* The current conversation still works if storage is unavailable. */}
  return clean;
}
export const homeKey = home => String(home?.listing_key || home?.id || '');
export const homeAddress = home => formatPropertyAddress(home || {}) || 'Selected home';
export const rooms = {
  kitchen: 'Kitchen',
  bedroom: 'Bedroom',
  primary_bedroom: 'Primary bedroom',
  bathroom: 'Bathroom',
  primary_bathroom: 'Primary bathroom',
  living_room: 'Living room',
  dining_room: 'Dining area',
  office: 'Office',
  yard: 'Yard',
  pool: 'Pool',
  garage: 'Garage',
  floor_plan: 'Floor plan',
  laundry: 'Laundry',
  patio: 'Patio'
};
const aliases = {
  kitchen: ['kitchen'],
  bedroom: ['bedroom'],
  primary_bedroom: ['primarybedroom', 'masterbedroom'],
  bathroom: ['bathroom', 'bath'],
  primary_bathroom: ['primarybathroom', 'primarybath', 'masterbathroom', 'masterbath'],
  living_room: ['livingroom', 'familyroom', 'greatroom'],
  dining_room: ['diningarea', 'diningroom'],
  office: ['office', 'study'],
  yard: ['yard', 'backyard'],
  pool: ['pool'],
  garage: ['garage'],
  floor_plan: ['floorplan'],
  laundry: ['laundry', 'laundryroom'],
  patio: ['patio', 'deck']
};
const compact = text => String(text || '').toLowerCase().replace(/[^a-z]/g, '');
export function roomMatches(media, room) {
  const names = aliases[room] || [];
  const exact = compact(media?.image_of);
  if (exact && !['other', 'unknown'].includes(exact)) return names.includes(exact);
  // Require the caption to identify the photo's subject, rather than mention a
  // kitchen elsewhere in a marketing paragraph. Unknown is better than a guess.
  return [media?.short_description, media?.long_description].some(value => {
    const text = String(value || '').trim().toLowerCase().replace(/^(photo|image) of (the )?/, '');
    const words = text.split(/[.,;:]/)[0].split(/[^a-z]+/).filter(Boolean);
    return names.some(name => words.slice(0, 3).some((_, i) => compact(words.slice(0, i + 1).join(' ')) === name));
  });
}
export function roomPhotoIndexes(media, room) {
  return media.flatMap((photo, index) => roomMatches(photo, room) ? [index] : []);
}
